import { Card, Paragraph } from '@digdir/designsystemet-react';

import styled from '../../../../../../styled';

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-7);
`;

export const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-4);
`;

export const StyledParagraph = styled(Paragraph)`
  padding-left: var(--ds-size-6);
`;

export const ButtonWrapper = styled.div`
  display: flex;
  margin-top: var(--ds-size-8);
  gap: var(--ds-size-2);
`;

export const PanelCard = styled(Card)`
  border-radius: var(--ds-border-radius-md);
  background: var(--ds-color-background-tinted);
`;

export const PanelWrapper = styled.div`
  display: flex;
  padding-top: var(--ds-size-2);
  flex-direction: column;
  gap: var(--ds-size-4);
`;

export const PanelRowWrapper = styled.div`
  align-items: start;
  display: grid;
  gap: var(--ds-size-4);
  grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
`;

export const RemoveButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
